import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    Button
} from '@chakra-ui/react'
import { RefObject } from 'react'

interface ClearStaleCheckoutsDialogProps {
    isOpen: boolean
    onClose: () => void
    onConfirm: () => Promise<void>
    isLoading: boolean
    cancelRef: RefObject<HTMLButtonElement>
    session: string
}

function ClearStaleCheckoutsDialog({
    isOpen,
    onClose,
    onConfirm,
    isLoading,
    cancelRef,
    session
}: ClearStaleCheckoutsDialogProps) {
    return (
        <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
            <AlertDialogOverlay>
                <AlertDialogContent>
                    <AlertDialogHeader fontSize="lg" fontWeight="bold">
                        Clear Stale Checkouts
                    </AlertDialogHeader>

                    <AlertDialogBody>
                        Are you sure you want to clear all stale checkouts for the{' '}
                        {session.toLowerCase()} session?
                        <br />
                        <br />
                        This will mark all incomplete checkouts as completed. This action
                        cannot be undone.
                    </AlertDialogBody>

                    <AlertDialogFooter>
                        <Button variant="outline" ref={cancelRef} onClick={onClose}>
                            Cancel
                        </Button>
                        <Button
                            colorScheme="red"
                            onClick={onConfirm}
                            isLoading={isLoading}
                            ml={3}
                        >
                            Clear Stale Checkouts
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    )
}

export default ClearStaleCheckoutsDialog
